export const fromSignUpPage = 'fs'
export const autoOtpSending = 'ao'
export const temporaryBlockedRetryUrl = 'tr'
